import {
  CreateDependsOnFactory,
  FormControlDependsOnSchema,
  FormControlDependsOnThenEnum,
  IFormControlDependsOnSchema,
  IValidation,
  ObjectFromList
} from "@cak-legacy/generation-core";
import { AbstractDependsOnMapper } from "./AbstractDependsOnMapper";
import { IDependsOn, INestedDependsOn } from "../../client/model/dependsOn";
import { createValidations } from "../ValidateMapper";
import { ValidationBuilder } from "../../builder/validationBuilder";
import { ValidateField } from "../../client/model/validation/validateField";

export class AddValidationsDependsOnMapper extends AbstractDependsOnMapper {
  convert(item: IDependsOn, fieldType: string): FormControlDependsOnSchema<any> {
    return this.convertField(this.getBaseProperties(item), fieldType, item.addValidations);
  }
  convertNested(item: INestedDependsOn, fieldType: string): FormControlDependsOnSchema<never[]> {
    return this.convertField(this.getBaseNestedProperties(item), fieldType, item.addValidations);
  }

  private convertField(
    baseProperties: IFormControlDependsOnSchema<any>,
    fieldType: string,
    validations?: ValidateField | null
  ): FormControlDependsOnSchema<any> {
    return {
      ...baseProperties,
      then: FormControlDependsOnThenEnum.AddValidations,
      addValidations: (_values: ObjectFromList<readonly [string], string | any[] | null | undefined>) =>
        this.convertValidations(fieldType, validations)
    };
  }

  convertValidations = (fieldType: string, validations?: ValidateField | null): IValidation[] => {
    return validations ? createValidations(new ValidationBuilder(fieldType), validations) : [];
  };
}
